import React, { useState, useRef, useEffect } from 'react';
import { UserAuth } from './context/AuthContext';
import { NavLink, useNavigate } from 'react-router-dom';
import { useStepContext } from './context/StepContext';
import ProfileContext from './context/ProfileContext';
import HrProfileImg from './assets/hr-profile.jpg';

const Header = () => {
  const { logOut, user } = UserAuth();
  const navigate = useNavigate();
  const { currentStep, totalSteps, progressPercent, isCompleted, resetProgress, stepLabels } = useStepContext();
  const { profile } = React.useContext(ProfileContext);

  // HR Contact Dropdown State
  const [showHrContact, setShowHrContact] = useState(false);
  const hrDropdownRef = useRef(null);

  // Click outside handler for HR dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (hrDropdownRef.current && !hrDropdownRef.current.contains(event.target)) {
        setShowHrContact(false);
      }
    };

    if (showHrContact) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showHrContact]);

  const handleSignOut = async () => {
    try {
      resetProgress();   // clear progress
      await logOut();
    } catch (error) {
    }
  };

  const handleProfile = () => {
    // navigate('/profile');
  }
  // shorName method is calculating shortname
  const shortName = user?.displayName?.split(" ")?.map((shortName) => {
    return shortName[0];
  });

  return (
    <header className="top-header sticky-top">
      <nav className="navbar navbar-dark bg-white navbar-expand-lg py-2" data-bs-theme="light">
        <div className="container gap-1">
          {/* <button className="navbar-toggler border border-primary rounded-2 text-primary px-2 p-1" type="button" data-bs-toggle="offcanvas" data-bs-target="#topNavbar" aria-controls="topNavbar">
            <span className="navbar-toggler-icon"></span>
            <i className="bi bi-list fs-4"></i>
          </button> */}

          <NavLink to="/account" className="navbar-brand d-flex flex-column flex-sm-row align-items-sm-center row-gap-1 column-gap-2 text-decoration-none p-0">
            <div className="brand-name lh-sm">Interview <span className="text-theme7">First</span></div>
            <div className="app-version d-grid gap-1">
              <div>BETA</div>
              <div>Version {process.env.REACT_APP_VERSION}</div>
            </div>
          </NavLink>

          <div className="offcanvas offcanvas-start text-bg-primary" tabIndex="-1" id="topNavbar" aria-labelledby="topNavbarLabel">
            <div className="offcanvas-header border-bottom border-secondary">
              <NavLink to="/account" className="navbar-brand d-flex d-lg-none align-items-center p-0 m-0">
                <div className="brand-name">Interview <span className="text-theme7">First</span></div>
                <div className="app-version d-grid gap-1">
                  <div>BETA</div>
                  <div>Version {process.env.REACT_APP_VERSION}</div>
                </div>
              </NavLink>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav justify-content-end">
                <li className="nav-item">
                  {/* <NavLink to={'/admin-login'} className="nav-link text-white" aria-current="page" >Admin Login</NavLink> */}
                </li>
                {/* <li className="nav-item">
                <NavLink to='/finance-login' className="nav-link text-white">Finance Login</NavLink>
              </li> */}
              </ul>
            </div>
          </div>

          <div className="d-flex flex-wrap align-items-center gap-1 gap-sm-2 gap-lg-3 ms-auto">
            {/* HR Contact Pill Button & Dropdown */}
            <div className="position-relative" ref={hrDropdownRef}>
              <button
                type="button"
                className="d-flex align-items-center gap-1 bg-white border rounded-pill pointer shadow-sm p-1"
                onClick={() => setShowHrContact(!showHrContact)} style={{ minWidth: '100px' }}
              >
                <div className="rounded-circle overflow-hidden flex-shrink-0" style={{ width: '30px', height: '30px', backgroundColor: '#d1fae5' }}>
                  <img src={HrProfileImg} alt="HR" className="w-100 h-100 object-fit-cover" />
                </div>
                <div className="text-start">
                  <div className="fw-bold text-dark lh-sm" style={{ fontSize: '13px' }}>Rehmat</div>
                  <div className="fs-12 text-primary small lh-1">Support</div>
                </div>
                <i
                  className="bi bi-chevron-down text-secondary mx-1"
                  style={{ transition: 'transform 0.2s', transform: showHrContact ? 'rotate(180deg)' : 'rotate(0deg)' }}
                ></i>
              </button>

              {/* HR Contact Dropdown Card */}
              {showHrContact && (
                <div className="position-absolute end-0 bg-white border rounded-3 shadow z-3 p-3 mt-2" style={{ minWidth: '240px' }}>
                  <div className="small fst-italic text-muted">Contact Number</div>
                  <div className="fw-bold main-heading text-dark">8076669690</div>
                  <hr className="my-2" />
                  <div className="small text-primary">Contact between 10AM to 7PM, Mon - Sat</div>
                </div>
              )}
            </div>

            <li className="nav-item dropdown user-logout">
              <NavLink to="#" className="nav-link text-white text-center p-0" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <div className="chip-wrapper">
                  <div className="chip-img bg-primary bg-opacity-10 border border-primary d-flex align-items-center justify-content-center rounded-circle overflow-hidden">
                    {profile?.userfetchedData?.user_photo ? (
                      <img className="w-100 h-100" src={profile?.userfetchedData?.user_photo} alt="User" style={{ objectFit: "cover" }} />
                    ) : (
                      <div className="small fw-semibold user-shortname text-primary">{shortName}</div>
                    )}
                  </div>
                </div>
              </NavLink>
              <ul className="dropdown-menu dropdown-menu-end caret-indicator shadow p-3 mt-2" style={{ width: "300px" }}>
                <div className="d-flex justify-content-between gap-2">
                  <div className="orgainization-name title-label fw-medium">{process.env.REACT_APP_ORG_NAME}</div>
                  <NavLink className="signout title-label pointer text-primary" onClick={handleSignOut}>Sign out</NavLink>
                </div>
                <div className="d-flex align-items-center gap-2 mt-3">
                  <div className="chip-wrapper">
                    <div className="chip-img d-flex align-items-center justify-content-center rounded-circle border overflow-hidden" style={{ height: "60px", width: "60px" }}>
                      <img className="w-100 h-100" src={profile?.userfetchedData?.user_photo || require('./assets/Avatar.png')} alt="User" style={{ objectFit: "cover" }} />
                    </div>
                  </div>
                  <div className="user-info overflow-hidden">
                    <div className="user-name text-capitalize">{user?.displayName}</div>
                    <div className="user-id title-label">{user?.email}</div>
                    {/* <div className="user-id title-label">
                  <div className="btn-link text-primary pointer" onClick={handleProfile}>View account</div>
                </div> */}
                  </div>
                </div>
              </ul>
            </li>
          </div>
        </div>
      </nav>

      {/* Progress */}
      <div className="progress-wrapper border-bottom border-primary-subtle py-2">
        <div className="container">
          <div className="progress-ribbon d-flex align-items-center gap-3">
            <span className="progress-label fs-12 fw-medium text-primary text-nowrap">
              {/* 🎯 Step {currentStep} of {totalSteps} */}
              {/* 🎯 Your Interview Progress */}
              🎯 Your Registration is in progress
            </span>
            <div className="progress-track rounded-pill overflow-hidden flex-grow-1">
              <div className="progress-fill rounded-pill"
                style={{
                  width: `${progressPercent}%`,
                  transition: 'width 0.4s ease-in-out'
                }}
              ></div>
            </div>
            <span className="progress-value fs-12 fw-semibold text-primary text-nowrap">
              {progressPercent === 100 ? 'All done! 🎉' : `${progressPercent}%`}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
